<template>
    <div class="page-table haberTanim mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.haberler.guncelleme.pageBaslik")}}
        </div>
        <el-row :gutter="10">
            <el-form status-icon :model="haberlerForm" :rules="rulesHaberler" ref="haberlerForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item
                                        :label='$t("src.views.apps.haberler.tanimlama.baslik")'
                                        prop="baslik">:
                                    <div v-if="linkVisible" style="float: right; display: flex">
                                        <div v-if="!VisibleA">
                                            <el-link target="_blank" :underline="false"
                                                     :href="this.path">
                                                {{this.path}}{{this.haberlerForm.link}}
                                            </el-link>
                                        </div>
                                        <el-button v-if="duzenleBtnVisible"
                                                   style="margin-left: 10px; margin-bottom: 5px"
                                                   v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                   size="mini">Düzenle
                                        </el-button>
                                        <span v-if="VisibleA">{{this.path}}</span>
                                        <el-input
                                                v-if="VisibleA" v-model="haberlerForm.link"
                                                v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                v-on:change="linkChange = false; $store.commit('changeTabsClose', false)"
                                                style="width: 50%" size="mini"></el-input>
                                    </div>
                                    <el-input
                                            v-model="haberlerForm.baslik"
                                            v-on:change="linkTespit(); $store.commit('changeTabsClose', false)"
                                            :placeholder='$t("src.views.apps.haberler.tanimlama.baslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.altbaslik")'
                                              prop="altBaslik">:
                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                              v-model="haberlerForm.altBaslik"
                                              :placeholder='$t("src.views.apps.haberler.tanimlama.altBaslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.icerik")'
                                              prop="icerik">:
                                    <div>
                                        <ckeditor :editor="editor" :config="editorConfig"
                                                  @input="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                  @blur="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                  v-model="haberlerForm.icerik"></ckeditor>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                <el-form-item>
                                    <el-checkbox v-model="checked">Sayfa'da Buton Olsun Mu?</el-checkbox>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                <el-form-item>
                                    <el-checkbox v-model="checked2">Video Olsun Mu?</el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-collapse  style="margin-top: 10px" v-model="activeCollapse">
                        <el-row :gutter="10">
                            <el-col v-if="checked" :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item v-if="checked" class=" animated fadeInDown card-shadow--medium" title='Buton Ayarları'
                                                  name="3">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                          prop="butonLink">:
                                                <el-input
                                                        v-model="haberlerForm.butonLink"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                          prop="buton">:
                                                <el-input
                                                        v-model="haberlerForm.buton"
                                                        placeholder='Buton Adı Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                            <el-col v-if="checked2" style="float: right" :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item  class=" animated fadeInDown card-shadow--medium" title='Video'
                                                   name="3">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24"  class="col-p">
                                            <el-form-item label='Video' prop="video">:
                                                <el-input
                                                        type="textarea"
                                                        :rows="5"
                                                        v-model="haberlerForm.video"
                                                        placeholder='Video URL Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                        </el-row>
                    </el-collapse>
                    <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                        <draggable
                                data-source="juju"
                                class="list-group"
                                group="a">
                            <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.resim") + " (800x600)"'
                                                      prop="resim">:
                                            <el-upload
                                                    class="resimler"
                                                    action=""
                                                    list-type="picture-card"
                                                    multiple
                                                    :file-list="imageListMain"
                                                    :auto-upload="false"
                                                    accept=".jpg,.jpeg,.png"
                                                    :on-change="imageUpload"
                                                    :on-preview="firstImage"
                                                    :on-remove="imageRemove">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                            <el-button style="margin-top: 15px" type="primary"
                                                       v-on:click="serverImageList"
                                                       @click="dialogServerVisible = true; " size="mini">
                                                Sunucudan
                                                Seç
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                      prop="seoBaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      id="seoBaslik"
                                                      @input="seoBaslikChange('seoBaslik')"
                                                      v-model="haberlerForm.seoBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                <template slot="append">{{seoBaslikLimit}}</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                      prop="seoIcerik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      type="textarea"
                                                      v-on:focus="seoicerikChange = false"
                                                      v-model="haberlerForm.seoIcerik"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.haberler.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        style="margin-bottom: 10px"
                                        size="mini" v-on:click="haberGuncelle('haberlerForm')"
                                        class="onayBtn"
                                        type="primary">
                                    {{$t('src.views.apps.haberler.guncelleme.haberGuncelle')}}
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.kategori")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="kategori">
                                            <el-select
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="haberlerForm.kategoriId"
                                                    :placeholder='$t("src.views.apps.haberler.tanimlama.kategoriPlace")'
                                                    style="width: 100%">
                                                <el-option v-for="item in kategoriListe"
                                                           :key="item.hkategoriId"
                                                           :label="item.baslik"
                                                           :value="item.hkategoriId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.kategoriAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.resimKonum")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="resimKonum">
                                            <el-button type="primary" size="mini" @click="drawerResimKonum = true">
                                                {{this.btnResim}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="haberlerForm.resimKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.resimKonum === '1'" style="float: right"
                                                 src="../../../assets/images/2.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.resimKonum === '2'" style="float: right"
                                                 src="../../../assets/images/5.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.resimKonum === '3'" style="float: right"
                                                 src="../../../assets/images/4.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.resimKonum === '4'" style="float: right"
                                                 src="../../../assets/images/3.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.resimKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.menuKonum")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="menuKonum">
                                            <el-button type="primary" size="mini" @click="drawerMenuKonum = true">
                                                {{this.btnMenu}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="haberlerForm.menuKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.menuKonum === '1'" style="float: right"
                                                 src="../../../assets/images/6.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.menuKonum === '2'" style="float: right"
                                                 src="../../../assets/images/9.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.menuKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.galeriKonum")' name="5">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="galeriKonum">
                                            <el-button type="primary" size="mini" @click="drawerGaleriKonum = true">
                                                {{this.btnGaleri}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="haberlerForm.galeriKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.galeriKonum === '1'" style="float: right"
                                                 src="../../../assets/images/7.png" width="50%" height="50%">
                                            <img v-if="haberlerForm.galeriKonum === '2'" style="float: right"
                                                 src="../../../assets/images/8.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.galeriKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.tarih")' name="6">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="tarih">
                                            <el-date-picker v-on:change="$store.commit('changeTabsClose', false)"
                                                            class="select-wide" type="datetime"
                                                            :placeholder='$t("src.views.apps.haberler.tanimlama.tarihPlace")'
                                                            :picker-options="dateRangeOptions"
                                                            v-model="haberlerForm.baslamaTarihi"
                                                            format="yyyy-MM-dd HH:mm:ss"
                                                            value-format="yyyy-MM-dd HH:mm:ss">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-checkbox style="margin-bottom: 20px" v-model="checkedTarih">
                                            {{$t("src.views.apps.haberler.tanimlama.bitisTarihi")}}
                                        </el-checkbox>
                                        <el-col v-if="checkedTarih" :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.haberler.tanimlama.bitisTarihi")'
                                                          prop="bitisTarihi">:
                                                <el-date-picker v-on:change="$store.commit('changeTabsClose', false)"
                                                                class="select-wide" type="datetime"
                                                                :placeholder='$t("src.views.apps.haberler.tanimlama.bitisTarihiPlace")'
                                                                :picker-options="dateRangeOptions"
                                                                v-model="haberlerForm.bitisTarihi"
                                                                format="yyyy-MM-dd HH:mm:ss"
                                                                value-format="yyyy-MM-dd HH:mm:ss">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.haberHakkinda")' name="10">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.sayac")'
                                                      prop="sayac">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-mask="'######'"
                                                      v-model="haberlerForm.sayac"></el-input>
                                        </el-form-item>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                            <el-form-item :label='$t("src.views.apps.haberler.tanimlama.begen")'
                                                          prop="begen">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-mask="'######'"
                                                          v-model="haberlerForm.begen"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        list-type="picture-card"
                        :on-change="serverImageUpload"
                        accept=".jpg,.jpeg,.png"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-delete"
                                                  @click="imageUploadtoServer(file)">
                                                    <i class="el-icon-plus"></i>
                                            </span>
                                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Resim Konumu"
                    :visible.sync="drawerResimKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="0" @change="changeKonum('resim','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="1" @change="changeKonum('resim','1')">
                            <img src="../../../assets/images/2.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="2" @change="changeKonum('resim','2')">
                            <img src="../../../assets/images/5.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="3" @change="changeKonum('resim','3')">
                            <img src="../../../assets/images/4.png" alt="Sol" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="4" @change="changeKonum('resim','4')">
                            <img src="../../../assets/images/3.png" alt="Üst" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Menü Konumu"
                    :visible.sync="drawerMenuKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.menuKonum" label="0" @change="changeKonum('menu','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.menuKonum" label="1" @change="changeKonum('menu','1')">
                            <img src="../../../assets/images/6.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.menuKonum" label="2" @change="changeKonum('menu','2')">
                            <img src="../../../assets/images/9.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Galeri Konumu"
                    :visible.sync="drawerGaleriKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.galeriKonum" label="0" @change="changeKonum('galeri','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.galeriKonum" label="1" @change="changeKonum('galeri','1')">
                            <img src="../../../assets/images/7.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.galeriKonum" label="2" @change="changeKonum('galeri','2')">
                            <img src="../../../assets/images/8.png" alt="Yatay,Küçük" width="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
    import draggable from "vuedraggable";
    import EventBus from '@/components/event-bus'

    let $ = JQuery;
    import seoService from '../../../WSProvider/SeoService'
    import controllerService from '../../../WSProvider/ControllerService'
    import haberService from '../../../WSProvider/HaberService'
    import haberKategoriService from '../../../WSProvider/HaberKategoriService'
    import notification from '../../../notification'
    import functions from '../../../functions'

    export default {
        name: "HaberlerDuzenle",
        components: {
            draggable,
        },
        watch: {
            imageListMain: function (val) {
                if (val.length === 1) {
                    this.haberlerForm.resimKonum = "1";
                    this.haberlerForm.galeriKonum = "0";
                } else if (val.length > 1) {
                    this.haberlerForm.galeriKonum = "1";
                } else {
                    this.haberlerForm.resimKonum = "0";
                    this.haberlerForm.galeriKonum = "0";
                }
            },
            checkedTarih: function (val) {
                if (val === false) {
                    this.haberlerForm.bitisTarihi = "";
                }
            },
        },
        mounted() {
            this.getKategoriListe();
            this.updateHaberKodu = this.$store.state.updateKodu;
            this.getHaberDetay(this.updateHaberKodu);
        },
        data() {
            return {
                checked: false,
                checked2: false,
                seoBaslikLimit: 0,
                path: haberService.path,
                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                dialogDocServerVisible: false,
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                dynamicTags: [],
                orjinalResimList: [],
                imageListMain: [],
                fileListMain: [],
                fileListServer: [],
                imageListServer: [],
                seoicerikChange: true,
                VisibleA: false,
                duzenleBtnVisible: true,
                dialogServerVisible: false,
                linkVisible: false,
                linkChange: true,
                haberDetayListKlon: [],
                updateData: [],
                updateDataDE: [],
                updateDataEN: [],
                checkedTarih: '',
                kategoriListe: [],
                updateHaberKodu: '',
                haberlerForm: {
                    kategoriId: '',
                    baslik: '',
                    link: '',
                    video: "",
                    buton: "",
                    butonLink: "",
                    altBaslik: '',
                    icerik: '',
                    resim: [],
                    resimKonum: '',
                    menuKonum: '',
                    galeriKonum: '',
                    kaynakca: '',
                    webSite: [],
                    baslamaTarihi: '',
                    bitisTarihi: '',
                    durum: '',
                    sayac: '',
                    begen: '',
                    seoBaslik: '',
                    seoIcerik: '',
                },
                dateRangeOptions: {
                    firstDayOfWeek: 1
                },
                rulesHaberler: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Haber Başlığı Giriniz",
                        trigger: 'blur'
                    }],
                    seoBaslik: [{
                        max: 70,
                        message: "Tavsiye edilen SEO Başlık limitini aştınız.",
                        trigger: 'change'
                    }],
                    seoIcerik: [{
                       max: 160,
                        message: "Tavsiye edilen SEO İçerik limitini aştınız.",
                        trigger: 'change'
                    }],
                },
            }
        },
        methods: {
            seoBaslikChange(id) {
                this.seoBaslikLimit = this.haberlerForm.seoBaslik.length;
                if (this.seoBaslikLimit > 70) {
                    $('#' + id).closest('div').find('div').addClass('limitAsim');
                } else {
                    $('#' + id).closest('div').find('div').removeClass('limitAsim');
                }
            },
            getKategoriListe() {
                haberKategoriService.kategoriList(1).then(response => {
                    if (response.status === 200) {
                        if (response.data.length === 0) {
                            notification.Status('warning', this, 'Kategori listesi boş! Lütfen önce kategori tanımlayınız.');
                        } else {
                            this.kategoriListe = response.data;
                        }
                        if (response.data.length > 0) {
                            this.haberlerForm.kategoriId = response.data[0].hkategoriId;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange && this.haberlerForm.icerik) {
                    const myStr = functions.strip_html_tags(this.haberlerForm.icerik);
                    this.haberlerForm.seoIcerik = myStr.substring(0, 140);
                } else this.haberlerForm.seoIcerik = '';
            },

            linkTespitLink() {
                let self = this;
                if (this.haberlerForm.link) {
                    seoService.linkKontrol(self.haberlerForm.link.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            self.haberlerForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.haberlerForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.haberlerForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (self.haberlerForm.baslik) {
                            self.haberlerForm.seoBaslik = self.haberlerForm.baslik.substring(0, 60);
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.haberlerForm.link = response.data;
                            }
                        } else if (!self.haberlerForm.baslik) {
                            self.linkVisible = false;
                            self.haberlerForm.link = '';
                            self.haberlerForm.seobaslik = '';
                        }
                    })
                }
            },
            getHaberDetay(haberKodu) {
                let self = this;
                haberService.haberDetay(haberKodu).then((response) => {
                    if (response.status === 200) {
                        if (response.data.anaResim) {
                            self.orjinalResimList.push(response.data.anaResim);
                            self.imageListMain.push({
                                name: response.data.anaResim,
                                url: haberService.imageUrlOrta + response.data.anaResim
                            });
                        }
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.orjinalResimList.push(e);
                                    self.imageListMain.push({
                                        name: e,
                                        url: haberService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data['belge']) {
                            response.data['belge'].forEach(function (e) {
                                if (e) {
                                    self.fileListMain.push({
                                        name: e,
                                        url: haberService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        self.haberlerForm.kategoriId = response.data.kategoriId;
                        self.haberlerForm.baslik = response.data.baslik;
                        self.linkVisible = true;
                        self.haberlerForm.link = response.data.link;
                        self.haberlerForm.altBaslik = response.data.altBaslik;
                        if (response.data.icerik) {
                            self.haberlerForm.icerik = functions.htmlDecode(response.data.icerik);
                        }
                        self.haberlerForm.resimKonum = response.data.resimKonum;
                        self.haberlerForm.menuKonum = response.data.menuKonum;
                        self.haberlerForm.galeriKonum = response.data.galeriKonum;
                        self.haberlerForm.baslamaTarihi = response.data.baslamaTarihi;
                        if (response.data.bitisTarihi) {
                            self.haberlerForm.bitisTarihi = response.data.bitisTarihi;
                            self.checkedTarih = true;
                        }
                        if (response.data.video) {
                            this.checked2 = true;
                            this.haberlerForm.video = functions.htmlDecode(response.data.video);
                        }

                        if (response.data.buton || response.data.butonLink) {
                            this.checked = true;
                            this.haberlerForm.buton = response.data.buton;
                            this.haberlerForm.butonLink = response.data.butonLink;
                        }
                        self.haberlerForm.durum = response.data.durum;
                        self.haberlerForm.sayac = response.data.sayac;
                        self.haberlerForm.begen = response.data.begen;
                        self.haberlerForm.seoBaslik = response.data.seoBaslik;
                        self.haberlerForm.seoIcerik = response.data.seoIcerik;
                        self.haberDetayListKlon = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: haberService.imageUrlOrta + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                        localStorage.setItem('imageListServer', JSON.stringify(response.data));
                    }
                })

            },
            imageUploadtoServer(file) {
                let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                if (obj === undefined) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    notification.Status('warning', this, 'Bu resim zaten mevcut');
                }
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, "haber-" + functions.randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },

            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.haberlerForm.baslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "haber-" + functions.randomText(7) + '-' + this.haberlerForm.link + ".jpg";
                        } else {
                            imgname = "haber-" + functions.randomText(7) + '-' + this.haberlerForm.link + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "haber-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "haber-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('haber', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            haberGuncelle(formName) {
                let self = this;
                for (var key in this.haberDetayListKlon) {
                    if (key !== 'webSite' && key !== 'resim' && key !== 'belge') {
                        if (this.haberDetayListKlon[key] !== this.haberlerForm[key]) {
                            if (this.haberlerForm[key] || this.haberlerForm[key] === '') {
                                var item = {
                                    type: key,
                                    value: this.haberlerForm[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    } else if (key === "resim") {
                        if (self.imageListMain.length === 0) {
                            if (self.orjinalResimList.length > 0) {
                                self.orjinalResimList.forEach(function (e) {
                                    updateList(self, 'resim', 0, e);
                                })
                            }
                        } else {
                            for (var i = 0; i < self.imageListMain.length; i++) {
                                if (i === 0) {
                                    if (self.imageListMain[0].name !== self.orjinalResimList[0]) {
                                        updateList(self, 'resim', 2, self.imageListMain[0].name);
                                        let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[0]);
                                        if (obj !== undefined) {
                                            updateList(self, 'resim', 1, self.orjinalResimList[0]);
                                        }
                                    }
                                } else {
                                    let obj = self.orjinalResimList.find(data => data === self.imageListMain[i].name);
                                    if (obj === undefined) {
                                        updateList(self, 'resim', 1, self.imageListMain[i].name);
                                    }
                                }
                            }
                            if (self.orjinalResimList.length > 0) {
                                for (var y = 1; y < self.orjinalResimList.length; y++) {
                                    let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[y]);
                                    if (obj === undefined) {
                                        updateList(self, 'resim', 0, self.orjinalResimList[y]);
                                    }
                                }
                            }
                        }
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid && this.updateData.length !== 0) {
                        haberService.haberGuncelle(this.updateHaberKodu, this.updateData).then((response) => {
                            if (response.status === 200) {
                                EventBus.$emit("haberList",true)
                                this.resetForm(formName);
                                notification.Status('success', this, 'Haber başarıyla güncellendi.');
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir haber zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    } else
                        notification.Status('warning', this, 'Değişiklik yapılmadı!');
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.imageListMain = [];
                this.fileListMain = [];
                this.haberlerForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "BultenDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "BultenDuzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            changeKonum(item, konum) {
                if (item === 'resim') {
                    this.drawerResimKonum = false;
                    this.btnResim = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Resim konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Resim konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Resim konumu "Alt" olarak seçildi.');
                            break;
                        case '3' :
                            notification.Status('success', this, 'Resim konumu "Sol" olarak seçildi.');
                            break;
                        case '4' :
                            notification.Status('success', this, 'Resim konumu "Üst" olarak seçildi.');
                            break;
                    }
                } else if (item === 'menu') {
                    this.drawerMenuKonum = false;
                    this.btnMenu = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Menü konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Menü konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Menü konumu "Alt" olarak seçildi.');
                            break;
                    }
                } else if (item === 'galeri') {
                    this.drawerGaleriKonum = false;
                    this.btnGaleri = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Galeri konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Galeri konumu "Dikey,Büyük" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Galeri konumu "Yatay,Küçük" olarak seçildi.');
                            break;
                    }
                }
            }

        }
    }

    function updateList(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }
</script>

<style scoped>
    .el-tag + .el-tag {
        margin-left: 10px;
    }


    .yanForm .card {
        margin-top: 10px;
    }

</style>